import * as material from '@nrwl/angular-material';
import { CommonModule } from '@angular/common';
import { Component, NgZone } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { environment } from '@nrwl/environment';

import { AuthService } from '@nrwl/rx-service-auth';
import { filter, first } from 'rxjs/operators';
import { Provider } from './index.module';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { AuthStateModule } from '@nrwl/rx-state-auth';
import { AuthModule } from './modules/auth/auth.module';

export const Library: any[] = [material.AngularMaterialModule];

export const Module: any[] = [
  AuthModule,
  RouterModule.forRoot([]),
  EffectsModule.forRoot([]),
  StoreModule.forRoot([]),
  AuthStateModule,
  !environment.production ? StoreDevtoolsModule.instrument() : [],
];
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [CommonModule, RouterModule, ...Library],
  providers: [...Provider],
})
export class AppComponent {
  constructor(
    private zone: NgZone,
    private router: Router,
    private authService: AuthService,
  ) {
    this.authService.clearStorage();
    this.setupPreloader();
  }
  setupPreloader() {
    this.zone.runOutsideAngular(() => {
      this.router.events
        .pipe(
          filter((event) => event instanceof NavigationEnd),
          first(),
        )
        .subscribe((data: any) => {
          const preloader = <any>document.querySelector('.site-preloader');
          preloader.addEventListener('transitionend', (event: TransitionEvent) => {
            if (event.propertyName === 'opacity') {
              preloader.remove();
            }
          });
          preloader.classList.add('site-preloader__fade');
        });
    });
  }
}
